export const REPLAY_TOUR_STEPS = {
  stepOne: 0,
  stepTwo: 1,
  stepThree: 2,
  stepFour: 3,
  stepFive: 4,
};
